import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import { selectors as featuresSelectors } from 'features';
import { containers as ErrorContainer } from 'error';

import AppContainer from 'common/components/AppContainer';
import AnnouncementBanner from 'common/components/AnnouncementBanner';
import EnvironmentBanner from 'common/components/EnvironmentBanner';
import Router from './Router';
import { history } from '../services';

const App = ({ isBannerAnnouncementActive }) => {
  const env = process.env.REACT_APP_ENV || 'local';

  const [hasDismissedBanner, setHasDismissedBanner] = useState(
    localStorage.getItem('dismissedAnnouncementBanner')
  );

  const dismissAnnouncementBanner = () => {
    localStorage.setItem('dismissedAnnouncementBanner', true);
    setHasDismissedBanner(true);
  };

  const renderEnvironmentBanner = () => {
    if (env === 'production') return;

    return <EnvironmentBanner env={env} />;
  };

  const renderAnnouncementBanner = () => {
    if (!isBannerAnnouncementActive || hasDismissedBanner) return;

    return (
      <AnnouncementBanner env={env} onDismiss={dismissAnnouncementBanner} />
    );
  };

  return (
    <AppContainer>
      <ConnectedRouter history={history}>
        {renderEnvironmentBanner()}
        {renderAnnouncementBanner()}
        <ErrorContainer>
          <Router />
        </ErrorContainer>
      </ConnectedRouter>
    </AppContainer>
  );
};

export default connect((state) => ({
  isBannerAnnouncementActive:
    featuresSelectors.isBannerAnnouncementActive(state),
}))(App);
